import React, { useState, useCallback } from 'react';
import _cloneDeep from 'lodash/cloneDeep';
import { format } from 'date-fns/esm';

import Post from '../projectPost/Post';

import { ReactComponent as ExpandArrowIcon } from './expand-arrow.svg';
import { useNavigate } from 'react-router-dom';

import './SubCategory.css';
import { useSelector } from '../../hooks/useSelector';

export const postsPages = {
    published: 'Published',
    invited: 'Invited',
    pending: 'Pending',
};

const SubCategory = ({
    page,
    subCategoryTitle,
    subCategories,
    data,
    notificationsCount = 0,
    viewInvitationPost = null,
    invitationsPostIds = null,
    pendingPostsCount,
}) => {
    const navigate = useNavigate();

    const { inProgress, notInProgress } = useSelector(state => state.publishedPosts);
    const [isExpand, setIsExpand] = useState(false);

    const renderPostsList = useCallback(
        selectedData => {
            return selectedData.map(item => {
                const handleNavigateClick = () => {
                    navigate(`/posts/${item.uid}`);
                };

                return (
                    <div
                        className="subcategory-post-wrap"
                        onClick={handleNavigateClick}
                        key={item.uid}
                    >
                        <Post
                            id={item.uid}
                            viewsCount={item.viewed.length}
                            reviewsCount={item.responseEmails.length}
                            rawPost={_cloneDeep(item)}
                            postStatus={item.status || null}
                            publisherUid={item.publisherUid}
                            date={format(item.createdTimestamp.toDate(), 'MMM dd, yyyy')}
                            title={item.title}
                            description={item.description}
                            budget={item.budget}
                            category={item.category}
                            briefLink={item.brief || item.notion || item.otherLink || ''}
                            page={page}
                            subCategoryTitle={subCategoryTitle}
                            subCategories={subCategories}
                            invitationsPostIds={invitationsPostIds}
                        />
                    </div>
                );
            });
        },
        [page, data, viewInvitationPost, invitationsPostIds]
    );

    const renderNotExpandList = useCallback(() => {
        if (data.length) {
            const notExpandList = data.slice(0, 3);
            return renderPostsList(notExpandList);
        } else return;
    }, [renderPostsList, data]);

    const renderExpandList = useCallback(() => {
        if (data.length > 3) {
            return renderPostsList(data);
        } else return renderNotExpandList();
    }, [renderPostsList, data]);

    const handleExpandToggle = useCallback(
        e => {
            e.target.closest('.expand-posts-list').classList.toggle('is-expand');
            setIsExpand(prevValue => !prevValue);
        },
        [isExpand]
    );

    const handleNavigateToCreate = useCallback(() => {
        navigate('/posts/create');
    }, [navigate]);

    return (
        <div className="post-subcategory-wrap">
            <div className="post-subcategory-header">
                <h2>{subCategoryTitle}</h2>
                {page === postsPages.invited &&
                subCategoryTitle !== subCategories.inProgress &&
                notificationsCount ? (
                    <div className="notifications new-invitations-label">
                        {`New ${notificationsCount}`}
                    </div>
                ) : null}
                {page === postsPages.pending &&
                subCategoryTitle === subCategories.pending &&
                pendingPostsCount ? (
                    <div className="notifications new-pendings-label">
                        {`New ${pendingPostsCount}`}
                    </div>
                ) : null}
                {/* {
                    !!(data.length > 3) &&
                    <button className='expand-posts-list' onClick={handleExpandToggle}>
                        <ExpandArrowIcon />
                    </button>
                } */}
            </div>
            <div className="posts-subcategory-list">
                {page === postsPages.published &&
                    subCategoryTitle === subCategories.publishedNotInProgress &&
                    !(!!inProgress.length || !!notInProgress.length) && (
                        <div className="no-posts-card-wrap">
                            <p className="no-posts-card-note">
                                You don&apos;t have any published projects yet
                            </p>
                            <button
                                type="button"
                                className="no-posts-card-create"
                                onClick={handleNavigateToCreate}
                            >
                                Create a new opportunity
                            </button>
                        </div>
                    )}
                {/* {
                    isExpand
                    ? renderExpandList()
                    : renderNotExpandList()
                } */}
                {renderPostsList(data)}
            </div>
        </div>
    );
};

export default SubCategory;
